import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { UserContext } from "./UserContext";
import { API_VERSION } from "../data/constants";

const HOST =
	process.env.NODE_ENV === 'development'
		? process.env.REACT_APP_DEV_SERVER_URL
		: process.env.REACT_APP_PROD_SERVER_URL;

export default function useAuth() {

    let navigate = useNavigate();

    const { setUser } = useContext(UserContext);

    const [error, setError] = useState(null);

    //set user in context and push them admin page
    const setUserContext = (response) => {

        setUser(response.data.user);
        axios.defaults.headers.Authorization = `Bearer ${response.token}`;  

        localStorage.setItem("@App:user", JSON.stringify(response.data.user));
        localStorage.setItem("@App:token", response.token);

        navigate("/admin",{ replace: true });
        window.location.reload();

    };

    //register user
    const registerUser = async data => {
        const { name, email, password, passwordConfirmation } = data;
        return axios
            .post(`${HOST}/api/${API_VERSION}/users/signup`, {
                name,
                email,
                password,
                passwordConfirmation,
            })
            .then(res => {
                setUserContext(res.data);
            })
            .catch(err => {
                setError(err.response.data);
            });
    };

    //login user
    const loginUser = async data => {
        const { email, password } = data;
        return axios
            .post(`${HOST}/api/${API_VERSION}/users/login`, {
                email,
                password,
            }, {withCredentials: true})
            .then(res => {
                setUserContext(res.data);
            })
            .catch(err => {
                setError(err.response.data);
            });
    };


    return {
        registerUser,
        loginUser,
        error,
    };
}
